import Cookies from "js-cookie";

const DEFAULT_UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

export class UtmParamsStorage {
  utmKeys = DEFAULT_UTM_KEYS;

  saveFor({ anuncioId, search = window.location.search }) {
    const storageKey = this.storageKey(anuncioId); 
    if (!storageKey) return;

    const utmParams = this.extractParamsFromSearch(search);

    if (Object.keys(utmParams).length === 0) return;

    try {
      UtmParamsStorage.setCookie(storageKey, JSON.stringify(utmParams));
    } catch (error) {
      console.error(error);
    }
  }

  extractParamsFromSearch(search) {
    const urlParams = new URLSearchParams(search);

    return DEFAULT_UTM_KEYS.reduce((params, key) => {
      const value = urlParams.get(key);
      if (value) params[key] = value;
      return params;
    }, {});
  }

  storageKey(anuncioId) {
    return UtmParamsStorage.buildStorageKey(anuncioId);
  }

  static setCookie(name, value, expireInDays = 7) {
    try {
      Cookies.set(name, value, {
        domain: MULTI_EMPRESA_COOKIES_DOMAIN,
        secure: MULTI_EMPRESA_COOKIES_SECURE,
        sameSite: MULTI_EMPRESA_COOKIES_SAMESITE,
        expires: expireInDays,
      });

      // Adicionei aqui essa validação pois a lib Cookies é muito permissiva
      // e não dispara erros, como queremos saber quando não acontece o set
      // deixei disparando o erro
      if (!Cookies.get(name)) throw new Error('Cookie utm não foi definido')
    } catch (error) {
      console.error(error);
    }
  }

  static getCookie(name) {
    return Cookies.get(name);
  }

  static buildStorageKey(anuncioId) {
    if (!UtmParamsStorage.hasValidAnuncioId(anuncioId)) return null;
    return `utm_${anuncioId}`;
  }

  static hasValidAnuncioId(anuncioId) {
    if (typeof anuncioId !== "string" || anuncioId.trim() === "") return false;
    return /^[0-9]+$/.test(anuncioId);
  }

  static getParams(anuncioId) {
    const storageKey = UtmParamsStorage.buildStorageKey(anuncioId);
    if (!storageKey) return null;

    try {
      const stored = UtmParamsStorage.getCookie(storageKey);
      if (!stored) return null;

      try {
        return JSON.parse(stored);
      } catch (error) {
        UtmParamsStorage.setCookie(storageKey, "", -1);
        return null;
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Insere campos hidden de UTM no form passado.
   * @param {HTMLFormElement} form - O form DOM element onde adicionar os campos
   * @param {string} anuncioId - O ID do anúncio para buscar os UTM params
   */
  static addHiddenUtmFieldsToForm(form, anuncioId) {
    if (!form || !UtmParamsStorage.hasValidAnuncioId(anuncioId.toString()))
      return;

    const utmParams = UtmParamsStorage.getParams(anuncioId);
    if (!utmParams) return;

    DEFAULT_UTM_KEYS.forEach(function (key) {
      const paramValue = utmParams[key];
      if (!paramValue) return;

      // Garante padrão de nome de campo igual ao simple_form, usando o nome do form
      const formName = "utm_metadata";
      const inputName = `${formName}[${key}]`;
      const inputId = `${formName}_${key}`;

      // Não duplicar se já existir
      let input = form.querySelector(`input[name="${inputName}"]`);
      if (!input) {
        // Cria a div container para o input, com as classes solicitadas
        const div = document.createElement("div");
        div.classList.add("control", "hidden", inputName, "filled");
        input = document.createElement("input");
        input.type = "hidden";
        input.name = inputName;
        input.id = inputId;
        div.appendChild(input);
        form.appendChild(div);
      }
      input.value = paramValue;
    });
  }
}
